import { c, classy, m } from '@onfido/castor';
import React from 'react';
export * from './splitContainerProps';
/**
 * Container for `Checkbox` and `Radio` input components, adding custom
 * indicator within <label> element.
 */
export const IndicatorContainer = ({ bordered, children: { input, children }, className, ...restProps }) => (React.createElement("label", { ...restProps, className: classy(c('input-label'), m({ bordered }), className) },
    input,
    React.createElement("span", { className: classy(c('input-indicator')), "aria-hidden": "true" }),
    children && React.createElement("span", null, children)));
//# sourceMappingURL=indicator-container.js.map